// extracted by mini-css-extract-plugin
var _1 = "container--Qxg7X";
var _2 = "loading--rJVIv";
export { _1 as "container", _2 as "loading" }
